export default __webpack_public_path__ + "static/media/053-online-payment.eff31f72.svg";